import React, { useCallback, useRef } from "react";
import { useQueries, useQuery, useSuspenseQueries, useSuspenseQuery } from "@tanstack/react-query";

import Loader from "components/general/Loader";
import {
  Route,
  Link,
  Routes,
  useLocation
} from "react-router-dom";


export const RSC_SIZE = {
  "FULL": 34,
  "DISCIPLINE": 3,
  "SEX": 1,
  "EVENT": 18,
  "PHASE": 4,
  "UNIT": 8,
};
var SpecialCharRSC = "-"
export const RSC_EMPTY = {
  "DISCIPLINE": SpecialCharRSC.repeat(RSC_SIZE.DISCIPLINE),
  "SEX": SpecialCharRSC.repeat(RSC_SIZE.SEX),
  "EVENT": SpecialCharRSC.repeat(RSC_SIZE.EVENT),
  "PHASE": SpecialCharRSC.repeat(RSC_SIZE.PHASE),
  "UNIT": SpecialCharRSC.repeat(RSC_SIZE.UNIT),
  "FULL": SpecialCharRSC.repeat(RSC_SIZE.FULL),
};

export function getDisciplineRSC(_rsc) {
  var ret = RSC_EMPTY.DISCIPLINE
  var init = 0;
  var end = RSC_SIZE.DISCIPLINE;
  if ((_rsc !== undefined) && (_rsc.length >= end)) {
    ret = _rsc.substring(init, end);
  }
  return ret;
}

export function getEventRSC(_rsc) {
  var ret = RSC_EMPTY.PHASE
  var init = 0;
  var end = RSC_SIZE.DISCIPLINE + RSC_SIZE.SEX + RSC_SIZE.EVENT;
  if ((_rsc !== undefined) && (_rsc.length >= end)) {
    ret = _rsc.substring(init, end);
  }
  return ret;
}















export const fetchData = async (_url, coomitError = true) => {
  if (_url !== undefined) {
    const controller = new AbortController();
    try {
      const response = await fetch(_url, {
      });
      if (!response.ok) {
        const message = `An error has occured About Page: ${response.status}`;
        console.log("ERROR:" + message)
      }
      const json = await response.json();
      controller.abort();
      return json;
    } catch (error) {
      controller.abort();
      if (coomitError) { throw new Error('MIRS ERROR CONECTION ' + _url); }
    }
  } else {
    return undefined;
  }
}

function useObtainData(options) {
  //if (typeof window === "undefined" || typeof document === "undefined") {
  //  return useSuspenseQuery(options);
  //} else {
  return useQuery(options);
  //}
}

function useObtainDataArray(options) {
  //if (typeof window === "undefined" || typeof document === "undefined") {
  //  return useSuspenseQueries(options);
  //} else {
  return useQueries(options);
  //}
}



export default function AppRouter() {
  let location = useLocation();
  const pathname = location.pathname?.replace(/(\/)+/g, "$1")?.split('/')

  return (
    <>
      <div>{location.pathname}</div>
      <div>{pathname[1]}</div>

      <div className='container navbar'>
        <Link to='/test'>Home change1</Link>
        <nav className='nav-links'>
          <Link className='p-3' to='/test/about'>About</Link>
          <Link to='/test/about1'>About 1</Link>
        </nav>
      </div>
      <hr />
      <Routes>
        <Route exact path="/test" element={<Home />} />
        <Route path="/test/about" element={< About />} />
        <Route path="/test/about1" element={<About1 />} />
      </Routes>
    </>
  );
}

function Home() {
  return (
    <div>
      <h2>Home</h2>
    </div>
  );
}

async function getData() {
  return await fetchData(`${process.env.REACT_APP_SERVER_URL}/RES_ByRSC~comp=OG2024~rsc=SHOXAPMT--------------QUAL000100--~disc=SHO~event=SHOXAPMT--------------~recordTypes=QWR,EQWR,QOR,EQOR~rscConfig=SHOXAPMT--------------QUAL000100--~rscImages=SHOXAPMT--------------QUAL000100--~lang=ENG.json`);
}

async function getData1() {
  return await fetchData(`${process.env.REACT_APP_SERVER_URL}/SCH_StartList~comp=OG2024~disc=SHO~lang=ENG.json`);
}

function About() {
  const { data, isError, isLoading } = useObtainData({
    queryKey: ['externalData'],
    queryFn: getData,
    staleTime: Infinity,
    refetchInterval: 5000,
    refetchIntervalInBackground: true,
  });
  if (isError) { return <div>Not available</div>; }
  if (isLoading) { return <Loader />; }
  return (
    <>
      <div>
        <h2>About</h2>
        <ul className='grid'>
          {Array.isArray(data?.records) && data?.records.map(({ recordCode, record }, i) => (
            <li key={i}>
              <h2>#{i + 1}</h2>
              <h3>{record?.description}</h3>
              <p>{recordCode} stars</p>
            </li>
          ))}
        </ul>
      </div>

      <AthResults />
    </>
  );
}

function About1() {
  const { data, isError, isLoading } = useObtainData({
    queryKey: ['externalData1'],
    queryFn: getData1,
    staleTime: Infinity,
    refetchInterval: 5000,
    refetchIntervalInBackground: true,
  });
  if (isError) { return <div>Not available</div>; }
  if (isLoading) { return <Loader />; }
  return (
    <div>
      <h2>About 1</h2>
      <ul className='grid'>
        {Array.isArray(data?.schedules) && data?.schedules?.map(({ startDate, endDate }, i) => (
          <li key={i}>
            <h2>#{i + 1}</h2>
            <h3>{startDate}</h3>
            <p>{endDate}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export const getUnits = async ({ queryKey }) => {
  const [, _competition, _language, _phase, scheduled, haveSchedule] = queryKey
  const _scheduled = (scheduled === undefined) ? 'Y' : scheduled  // if null use Y
  const _haveSchedule = (haveSchedule === undefined) ? 'true' : haveSchedule  // if null use true
  const url = `${process.env.REACT_APP_SERVER_URL}/SEL_Units~comp=${_competition}~lang=${_language}~phase=${_phase}~scheduled=${_scheduled}~haveSchedule=${_haveSchedule}.json`
  console.log(url)
  return await fetchData(url);
}




export const getResultsRSC = async ({ queryKey }) => {
  const [, _competition, _rsc, _language, _rscConfig, subcode, recordTypes, _rscImages, recordEvent] = queryKey
  const _disc = getDisciplineRSC(_rsc);
  const _event = recordEvent ? recordEvent : getEventRSC(_rsc);

  const defaultRecordOly = process.env.REACT_APP_RECORDS;
  const defaultRecordParas = process.env.REACT_APP_RECORDS_PARAS;
  const defaultRecordByDiscipline = process.env['REACT_APP_RECORDS_' + _disc];
  const defaultRecord = false ? defaultRecordParas.split(",") : defaultRecordByDiscipline ? defaultRecordByDiscipline?.split(",") : defaultRecordOly?.split(",");
  const _recordTypes = recordTypes || defaultRecord

  const rscCfg = _rscConfig ? _rscConfig : _rsc // if null use rsc
  const rscImg = _rscImages ? _rscImages : _rsc // if null use rsc

  let url = `${process.env.REACT_APP_SERVER_URL}/RES_ByRSC~comp=${_competition}~rsc=${_rsc}~disc=${_disc}~event=${_event}~recordTypes=${_recordTypes}~rscConfig=${rscCfg}~rscImages=${rscImg}~lang=${_language}.json`
  if (subcode) {
    url = `${process.env.REACT_APP_SERVER_URL}/RES_ByRSC~comp=${_competition}~rsc=${_rsc}~disc=${_disc}~event=${_event}~recordTypes=${_recordTypes}~rscConfig=${rscCfg}~rscImages=${rscImg}~lang=${_language}~subcode=${subcode}.json`
  }

  return await fetchData(url);

}



function AthResults() {
  //GET UNITS IN PHASE

  //const context = useContext(InitialDataContext);

  const mirs_competition = "OG2024"
  //const mirs_discipline = "ATH"
  const mirs_language = "ENG"


  const { data: unitsData, isError: unitsError, isLoading: unitsLoading } = useObtainData(
    {
      queryKey: ['unitsPhase', mirs_competition, mirs_language, 'ATHW100M--------------PREL', 'S'],
      queryFn: getUnits,
      refetchInterval: 5000,
      //staleTime: Infinity,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
    }
  );



  let queryArray = []
  //GET ALL RESULTS IN PHASE 
  unitsData?.phase?.units?.forEach((unit) => {
    //console.log(unit.code)
    queryArray.push({
      queryKey: ['resultsData', mirs_competition, unit.code, mirs_language, 'ATHW100M--------------PREL-------', undefined, "", undefined, ""],
      queryFn: getResultsRSC,
      refetchInterval: 5000,
      //staleTime: 5000,
      refetchIntervalInBackground: true,
    })
  });


  //  const results =useQueries({ queries: queryArray });




  const results = useObtainDataArray({ queries: queryArray });

  const isLoading = unitsLoading || results.some(result => result.isLoading)
  const isError = unitsError || results.some(result => result.isError)

  if (isError) { return <div>Not available</div>; }
  if (isLoading) { return <Loader />; }



  return (

    <div className="context" >
      <h1>SSR Results</h1>
      {Array.isArray(results) && results.map((res, index) => {
        if (res?.data?.results?.items !== undefined)
          return (
            <div key={index}>
              <h2>{res?.data?.results?.eventUnit?.description}</h2>
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col" className="w-5">SortOrder</th>
                    <th scope="col" className="w-5">Bib</th>
                    <th scope="col">Name</th>
                    <th scope="col" className="w-5">results</th>
                    <th scope="col" className="w-5">IRM</th>
                  </tr>
                </thead>
                <tbody>
                  {res?.data?.results?.items.map((item, index) =>
                    <tr key={index}>
                      <td>{item?.resultRank}</td>
                      <td>{item?.bib}</td>
                      <td>{item?.participant?.name}</td>
                      <td>{item?.resultData}</td>
                      <td>{item?.resultIrm}</td>


                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )

      })
      }

    </div>

  );

}
